import { Storage } from './storage';
import { Cookie } from './cookie';
import { STORAGE_WHITE_LIST } from '../constants';

/**
 * Clear localStorage, Cookies and sessionStorage
 */
export function clearAll(): void {
    const storage = {};
    STORAGE_WHITE_LIST.forEach((key) => {
        if (Storage.getItem(key)) {
            storage[key] = Storage.getItem(key);
        }
    });
    Storage.clear();
    Cookie.removeAll();
    window.sessionStorage.clear();

    for (const key in storage) {
        Storage.setItem(key, storage[key]);
    }
}
